<template>
  <div>
    <div class="h60"></div>
    <div class="top fix">
      <div class="menuTab">
        <div class="logo" @click="jumpBack()">
          <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/logo.svg" alt />
        </div>
        <div class="module">
          <template v-for="(item, ind) in menu">
            <div class="item" @click="topBtn(ind, item.path)"
              :class="{ active: topActive == item.path }" :key="ind">
              {{ item.title }}
            </div>
          </template>
        </div>
        <div class="shop">
          <!-- <img class="icon" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/用户.png" width="20" height="20" /> -->
          <!-- <div class="title">{{ this.$store.getters.loginUserInfo.shopTitle }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMenuList  } from "@/api/sellerController";
export default {
  name: "",
  components: {},
  props: {
    paths:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  data() {
    return {
      topActive: "customTable",
      menu: [
       {
          tittle: "自定义报表",
          path: "customTable",
          show: false,
          // permission:'industry:solution'
        },
        {
          tittle: "实时数据",
          path: "realTimeData",
          show: false,
          // permission:'industry:strategy'
        },
   
        {
          tittle: "智能BI",
          path: "customTable",
          show: false,
          // permission:'industry:solution'
        },
        {
          tittle: "定制报表",
          path: "customTable",
          show: false,
          // permission:'industry:solution'
        },
      ],
    };
  },
  computed: {},
  created() { },
  mounted() {
    getMenuList().then(res=>{
      if(res.code == 1){
        // let list = res.data.find(item=>item.path == '/bi');
        // this.menu = list.children;
        // let biTable = list.children.find(item=>item.path == 'customTable');
        // this.$store.commit('setBiTableList', biTable);
        // this.$emit('biList', list);
        // this.topActive = this.$route.matched[1].path.split('/bi/')[1]
        // 侧边栏路由更改,上面为旧
        let list = res.data.find(item=>item.path == '/analysis');
        let biList = list.children.find(item=>item.path == 'bi');
        this.menu = biList.children;
        let biTable = biList.children.find(item=>item.path == 'customTable');
        this.$store.commit('setBiTableList', biTable);
        this.$emit('biList', biList);
        this.topActive = this.$route.matched[1].path.split('/bi/')[1]
      }
    })
  },
  methods: {
    topBtn(type, path) {
      
      if(path == 'realTimeData'){
        window.open("/platform/bi/"+path, "_blank");
      }else{
        this.topActive = path;
        let biTable = this.menu.find(item=>item.path == 'customTable');
        this.$store.commit('setBiTableList', biTable);
        this.$router.push("/bi/" + path);
      }
      
    },
    jumpBack() {
      sessionStorage.removeItem('pathsOne')
      window.open("/platform/home", "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.h60 {
  height: 60px;
}

.fix {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}

.top {
  background-color: #ffffff;

  .menuTab {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 auto;
    min-width: 1066px;
    // width: 1200px;

    .logo {
      width: 200px;
      height: 43px;
      cursor: pointer;
      text-align: center;
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
    }

    .module {
      display: inline-block;
      height: 60px;

      .item {
        position: relative;
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #666666;
        line-height: 60px;
        text-align: center;
        margin-left: 40px;
        cursor: pointer;
        height: 60px;
      }

      .active {
        position: relative;
        font-weight: 600;
        color: #1F1F1F;
      }

      .active::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 0);
        width: 44px;
        height: 3px;
        background: #ffffff;
        border-radius: 4px;
      }
    }

    .shop {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: end;

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 20px;
      }

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #666666;
        line-height: 60px;
        text-align: center;
        margin-left: 4px;
      }
    }
  }
}
</style>
